import { Icon } from "@/components/Icon";
import React from "react";

// Error message mapping (add all required messages here)
const errorMessageMap = {
  "validation.residualValue.tooLow": "Der Restwert ist zu niedrig.",
  "validation.calculationNotPossible":
    "Berechnung ist für dieses Fahrzeug nicht möglich.",
  "validation.vehicle.ageGroup.tooOldAtLeasingEnd":
    "Das Fahrzeug am Ende des Leasingvertrags ist für seine Altersgruppe zu alt",
};

const CalculatorErrorDisplay = ({ error }) => {
  let displayMessage = "";

  // If there is an error message on the top level of errorResponse, use it
  if (
    error?.errorResponse?.messageKey &&
    errorMessageMap[error.errorResponse.messageKey]
  ) {
    displayMessage = errorMessageMap[error.errorResponse.messageKey];
  }
  // Otherwise, try to find a subMessage to display
  else if (error?.errorResponse?.subMessages?.length > 0) {
    const firstSubMessage = error.errorResponse.subMessages[0];
    if (errorMessageMap[firstSubMessage.messageKey]) {
      displayMessage = errorMessageMap[firstSubMessage.messageKey];
    }
  }
  if (!displayMessage) return <div></div>;
  return (
    <div className="bg-alert font-medium flex justify-center rounded-md p-6 text-white ">
      <Icon type="info" className="w-8 h-8 mr-4 -mt-3" />
      {displayMessage}
    </div>
  );
};

export default CalculatorErrorDisplay;
